import React, { Component } from "react"
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import IncidentKeys from "../../../../Keys/IncidentKeys"

interface IncidentControlsBarProps {
    isDirty: boolean
    downloadIncident: Function
    deleteIncident: Function
    saveIncident: Function
    formatRb: Function
    loading: boolean
    readOnly: boolean
}

class IncidentControlsBar extends Component<IncidentControlsBarProps, {}> {

    render() {

        const readOnly = this.props.readOnly

        const DownloadToolTip = (
            <Tooltip id="uac-tool-tip">
                Delete this incident
            </Tooltip>
        )

        const SaveToolTip = (
            <Tooltip id="uac-tool-tip">
                Save changes
            </Tooltip>
        )

        const CantSaveToolTip = (
            <Tooltip id="uac-tool-tip">
                Nothing to save
            </Tooltip>
        )

        return (
            <div className="IncidentControlsBar" id="incident-controls-bar">
                {!this.props.isDirty && !this.props.loading && !readOnly && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={DownloadToolTip}>
                    <div className="IncidentControlBarBtn" id="delete-incident-btn" onClick={() => this.props.deleteIncident()}>
                        <span className="material-icons">delete</span>
                    </div>
                </OverlayTrigger>}
                {this.props.isDirty && !this.props.loading && !readOnly && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={SaveToolTip}>
                    <div className="IncidentControlBarBtn" id="update-incident-save-btn" onClick={() => this.props.saveIncident(this.props.formatRb(IncidentKeys.UpdateWorkCompIncidentPostKeys))}>
                        <p>Save</p>
                        <span className="material-icons">save</span>
                    </div>
                </OverlayTrigger>}
                {!this.props.isDirty && !this.props.loading && !readOnly && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={CantSaveToolTip}>
                    <div className="IncidentControlBarBtn" id="update-incident-cant-save-btn">
                        <p>Save</p>
                        <span className="material-icons">save</span>
                    </div>
                </OverlayTrigger>}
                {this.props.loading && <div className="IncidentControlBarLoadSpinner">
                    <Spinner id="incident-control-bar-load-spinner" animation="border" />
                </div>}
            </div>
        )
    }
}

export default IncidentControlsBar